import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectIsPeriodAvailable(state: IAppState): boolean {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  const {
    publishOptions: { selectedPlacingType, periodIds },
  } = selectedService;

  return selectedPlacingType === EPlacingType.balance && periodIds.length > 0;
}
